import BigNumber from 'bignumber.js';

import type { ProductLeftoverData } from '@app/pages/Warehouses/components/ProductLeftover/types';

const normalizeAmount = (value: unknown): BigNumber | null => {
  if (typeof value !== 'number' && !BigNumber.isBigNumber(value)) return null;

  const amount = new BigNumber(value);
  return amount.isFinite() ? amount : null;
};

export const getProductLeftover = ({
  amount: rawAmount,
  physicalAmount: rawPhysicalAmount,
  creditAmount: rawCreditAmount,
  hasCreditResidual,
  unit,
}: ProductLeftoverData) => {
  const amount = normalizeAmount(rawAmount);
  const physicalAmount = normalizeAmount(rawPhysicalAmount);
  const creditAmount = normalizeAmount(rawCreditAmount);
  const normalizedUnit = unit?.trim();
  const suffix = normalizedUnit ? ` ${normalizedUnit}` : '';
  const format = (value: BigNumber) =>
    `${value.toFormat({
      decimalSeparator: ',',
      groupSeparator: '\u00a0',
      groupSize: 3,
    })}${suffix}`;
  const negativeAmount = amount?.isLessThan(0);
  const negativeCredit = creditAmount?.isLessThan(0);
  const isDeficit = negativeAmount || negativeCredit || !!hasCreditResidual;
  const deficitAmount = negativeAmount
    ? amount
    : negativeCredit
    ? creditAmount
    : null;

  const text = isDeficit
    ? deficitAmount !== null
      ? `Дефицит: ${format(deficitAmount.abs())}`
      : normalizedUnit
      ? `Дефицит (${normalizedUnit})`
      : 'Дефицит'
    : amount !== null
    ? `Остаток: ${format(amount)}`
    : '—';
  const type = isDeficit
    ? 'danger'
    : amount?.isGreaterThan(0)
    ? 'success'
    : 'secondary';

  return {
    text,
    type,
    physicalText: physicalAmount?.isGreaterThan(0)
      ? `Физический остаток: ${format(physicalAmount)}`
      : null,
  } as const;
};
